// eslint-disable-next-line import/default
import detailsMixin from './detailsMixin';
export default {
  name: 'NiotaClassicGwMgmtDetailsForm',
  mixins: [detailsMixin],
  data: function () {
    return {};
  },
  methods: {
    formatLastPacketTime(duration) {
      const durationHours = Math.floor(duration);
      const durationMinutes = Math.round(duration * 60) - durationHours * 60;
      const hoursString = this.$i18n_tc('NiotaClassic.GWMonitoring.hours', durationHours, {
        n: durationHours
      });
      const minutesString = this.$i18n_tc('NiotaClassic.GWMonitoring.minutes', durationMinutes, {
        n: durationMinutes
      });
      if (durationMinutes > 0 && durationHours < 24) {
        return `${hoursString} ${minutesString}`;
      }
      return hoursString;
    },
    copyToClipboard(event, data) {
      let value = '';
      if (typeof data === 'object' && data !== null) {
        value = JSON.stringify(data);
      } else if (typeof data === 'string') {
        value = data;
      }
      event.stopPropagation();
      // create textarea to copy from
      const copyElement = document.createElement('textarea');
      copyElement.value = value;
      // set styles to hide textarea from viewport
      copyElement.style.position = 'absolute';
      copyElement.style.top = '-99999px';
      // add to element to body otherwise we can't select/copy
      document.body.appendChild(copyElement);
      // copy text
      copyElement.select();
      document.execCommand('copy');
      // remove element
      copyElement.remove();
    }
  }
};